module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/soluzioni_cloud_slider-00ccc0f5396ae1d335790de1e9b31506.png";